import { render, staticRenderFns } from "./pricelist.vue?vue&type=template&id=9647f5d4&"
import script from "./pricelist.vue?vue&type=script&lang=js&"
export * from "./pricelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9647f5d4')) {
      api.createRecord('9647f5d4', component.options)
    } else {
      api.reload('9647f5d4', component.options)
    }
    module.hot.accept("./pricelist.vue?vue&type=template&id=9647f5d4&", function () {
      api.rerender('9647f5d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2rpRBnaeS0D7f/JS/comp/pricelist.vue"
export default component.exports